import jsPDF from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment'
import QRCode from 'qrcode'
import { FRONT_BASE_URL } from 'src/config/Request'
const HrDigitalizationPDF = (data) => {
  const doc = new jsPDF()
  const count = data.length
  const maxIndex = count - 1
  const pageWidth = doc.internal.pageSize.width
  let yPositionIndex = 80
  data.map((pdfData, index) => {
    const qrCodeTextCover = FRONT_BASE_URL + 'employee-profile?id=1' + pdfData.id
    QRCode.toDataURL(qrCodeTextCover, { width: 50 }, (err, url) => {
      if (err) {
        console.error(err)
      } else {
        // Adjust yPosition after the table
        doc.addImage(url, 'PNG', 90, 185, 37, 37)
      }
    })

    doc.setFont('helvetica', 'bold')
    doc.setFontSize(18)
    doc.setTextColor('black')

    const text0 = 'WAHINDUSTRIESLIMITED'
    const normalText = 'INDUSTRIES'
    const textWidth =
      (doc.getStringUnitWidth(text0) * doc.internal.getFontSize()) / doc.internal.scaleFactor

    const boldTextWidth =
      (doc.getStringUnitWidth(normalText) * doc.internal.getFontSize()) / doc.internal.scaleFactor

    const textX = pageWidth - 94 - textWidth / 2
    const textY = 26

    doc.text('WAH', textX, textY, { align: 'center' })

    doc.setFont('helvetica', 'normal')
    doc.text('INDUSTRIES', 103.5, textY, { align: 'center' })
    doc.setFont('helvetica', 'bold')
    doc.text('LIMITED', 135.5, textY, { align: 'center' })

    doc.setFontSize(12)

    doc.setFont('helvetica', 'bold')
    doc.setTextColor('black')
    doc.text('(HR Department)', pageWidth - 100, 31, { align: 'center' })

    function drawLine(x1, y1, x2, y2) {
      doc.setLineWidth(0.5)
      doc.setDrawColor(0)
      doc.line(x1, y1, x2, y2)
    }

    const textWidth1 =
      (doc.getStringUnitWidth('(HR Department)') * doc.internal.getFontSize()) /
      doc.internal.scaleFactor
    const textX1 = pageWidth - 100 - textWidth1 / 2
    const textY1 = 27
    const lineHeight1 = 5

    drawLine(textX1, textY1 + lineHeight1, textX1 + textWidth1, textY1 + lineHeight1)

    doc.setFontSize(11.5)
    doc.setFont('helvetica', 'normal')
    doc.text(`To,`, 17, 40, { align: 'left' })
    doc.setFont('helvetica', 'bold')
    doc.text(`${pdfData.full_name}`, 17, 44, { align: 'left' })
    doc.setFont('helvetica', 'normal')
    doc.text(`${pdfData.designation.name}`, 17, 48, { align: 'left' })
    doc.text(`${pdfData.department.name} Department`, 17, 52, { align: 'left' })
    doc.text(`WIL HQ`, 17, 56, { align: 'left' })

    const text = 'DIGITALIZATION OF THE HR RECORD'

    doc.setFontSize(11.5)
    doc.setFont('helvetica', 'normal')
    doc.setTextColor('black')

    doc.text('Subject:', 17, 70)
    doc.setFont('helvetica', 'bold')
    doc.text(text, 35, 70)

    const textWidth2 = doc.getTextWidth(text)
    const textX2 = 35
    const textY2 = 70

    function drawLine(x1, y1, x2, y2) {
      doc.setLineWidth(0.5)
      doc.setDrawColor(0)
      doc.line(x1, y1, x2, y2)
    }

    const lineHeight2 = 0.5
    drawLine(textX2, textY2 + lineHeight2, textX2 + textWidth2, textY2 + lineHeight2)

    doc.setFontSize(11.5)
    doc.setFont('helvetica', 'normal')
    doc.setTextColor('black')

    doc.text('Reference: - Letter No. HR/109/ dated 10 Jan 2024', 17, 75)

    doc.setFontSize(11.5)
    doc.setFont('helvetica', 'bold')
    doc.setTextColor('black')

    doc.text('deactivation of biometric attendance.', 38, 99.3)

    const TwoTable = [
      [
        {
          content:
            '          In continuation of above reference letter, it is to intimate that your employee form is still not updated in ERP software. This might cause due to non-submission of the form or due to the missing desired supporting documents. Failure to submit the required employee form by 14 Feb 2024 may result in the',
          styles: { halign: 'justify', fontSize: 11.5 },
        },
      ],
      [
        {
          content: '',
        },
      ],
      [
        {
          content:
            '          In order to avoid any inconvenience, it is requested to please submit the form on or before 14th February 2024. Your usual support and cooperation would highly be appreciated.',
          styles: { halign: 'justify', fontSize: 11.5 },
        },
      ],
    ]
    const text2 = `Letter No: HR/2/${pdfData.id}/ Dated: ` + moment().format('DD MMMM YYYY')

    doc.setFont('helvetica', 'bold')
    doc.setFontSize(11.5)
    doc.setTextColor('black')
    doc.text(text2, 110, 150, { align: 'center' })

    const textWidth3 = doc.getTextWidth(text2)
    const textX3 = 69.5
    const textY3 = 145.8

    function drawLine(x1, y1, x2, y2) {
      doc.setLineWidth(0.5)
      doc.setDrawColor(0)
      doc.line(x1, y1, x2, y2)
    }

    drawLine(textX3, textY3 + 5, textX3 + textWidth3, textY3 + 5)

    const ThreeTable = [
      [
        {
          content: 'Cc: -',
          styles: { halign: 'left', fontSize: 11.5 },
        },
      ],
      [
        {
          content: 'a.\t Employee Office File\t\t}\t\tFor record, please.',
          styles: { halign: 'left', fontSize: 11.5 },
        },
      ],
    ]
    doc.setFontSize(10)
    doc.setFont('helvetica', 'italic')
    const text3 = 'This is a system-generated letter hence requires no signature or stamp'

    doc.text(text3, 110, 230, { align: 'center' })

    const textWidth4 = doc.getTextWidth(text3)
    const textX4 = 55
    const textY4 = 225.5

    function drawLine(x1, y1, x2, y2) {
      doc.setLineWidth(0.5)
      doc.setDrawColor(0)
      doc.line(x1, y1, x2, y2)
    }

    drawLine(textX4, textY4 + 5, textX4 + textWidth4, textY4 + 5)

    // doc.autoTable({
    //   startY: yPositionIndex,
    //   margin: { top: 40 }, // Header rows for first table
    //   body: OneTable, // Body rows for first table
    //   theme: 'plain',
    //   tableLineColor: '#ffffff',
    //   tableLineWidth: 0.2,
    //   tableWidth: 'auto',
    //   styles: {
    //     lineColor: '#ffffff',
    //     lineWidth: 0.2,
    //     halign: 'center',
    //     font: 'helvetica',
    //   },

    // })
    // const gapBetweenTable12 = 14
    // const startYForTable2 = doc.autoTable.previous.finalY + gapBetweenTable12
    doc.autoTable({
      startY: yPositionIndex,
      margin: { top: 40 },
      body: TwoTable, // Body rows for second table
      theme: 'plain',
      tableLineColor: '#ffffff',
      tableLineWidth: 0.2,
      tableWidth: 'auto', // Set table width automatically
      styles: {
        lineColor: '#ffffff',
        lineWidth: 0.2,
        halign: 'center',
        font: 'helvetica',
      },
    })

    const gapBetweenTable2333 = 30
    const startYForTable3333 = doc.autoTable.previous.finalY + gapBetweenTable2333
    doc.autoTable({
      startY: startYForTable3333,
      margin: { top: 40 },
      body: ThreeTable, // Body rows for second table
      theme: 'plain',
      tableLineColor: '#ffffff',
      tableLineWidth: 0.2,
      tableWidth: 'auto', // Set table width automatically
      styles: {
        lineColor: '#ffffff',
        lineWidth: 0.2,
        halign: 'center',
        font: 'helvetica',
      },
    })
    doc.addPage()

    // const gapBetweenTable34 = 12
    // const startYForTable4 = doc.autoTable.previous.finalY + gapBetweenTable34
    // doc.autoTable({
    //   startY: startYForTable4,
    //   margin: { top: 40 },
    //   head: OtherDetailsTable.slice(0, 1), // Header rows for second table
    //   body: OtherDetailsTable.slice(1), // Body rows for second table
    //   theme: 'plain',
    //   tableLineColor: '#3c4b64',
    //   tableLineWidth: 0.2,
    //   tableWidth: 'auto', // Set table width automatically
    //   headStyles: { fillColor: [217, 218, 219] },
    //   styles: {
    //     lineColor: '#3c4b64',
    //     lineWidth: 0.2,
    //     halign: 'center',
    //     font: 'helvetica',
    //   },
    //   didDrawPage: function (data) { },
    // })

    // const gapBetweenQuestionTables = 6
    // const startYForTable10 = doc.autoTable.previous.finalY + gapBetweenQuestionTables
    // doc.autoTable({
    //   startY: startYForTable10,
    //   margin: { top: 40 },
    //   body: QuestionTable,
    //   theme: 'plain',
    //   tableLineColor: '#3c4b64',
    //   tableLineWidth: 0.2,
    //   tableWidth: 'auto', // Set table width automatically
    //   styles: {
    //     lineColor: '#3c4b64',
    //     lineWidth: 0.2,
    //     halign: 'center',
    //     font: 'helvetica',
    //   },
    //   didDrawPage: function (data) { },
    // })
    // const gapBetweenBankTables = 8
    // const startYForTable11 = doc.autoTable.previous.finalY + gapBetweenBankTables
    // doc.autoTable({
    //   startY: startYForTable11,
    //   margin: { top: 40 },
    //   head: BankDetailTable.slice(0, 1), // Header rows for second table
    //   body: BankDetailTable.slice(1), // Body rows for second table
    //   theme: 'plain',
    //   tableLineColor: '#3c4b64',
    //   tableLineWidth: 0.2,
    //   tableWidth: 'auto', // Set table width automatically
    //   headStyles: { fillColor: [217, 218, 219] },
    //   styles: {
    //     lineColor: '#3c4b64',
    //     lineWidth: 0.2,
    //     halign: 'center',
    //     font: 'helvetica',
    //   },
    //   didDrawPage: function (data) { },
    // })
    // const gapBetweenReferenceTables = 8
    // const startYForTable12 = doc.autoTable.previous.finalY + gapBetweenReferenceTables
    // const ReferenceDetails = () => {
    //   let employee_references = []
    //   if (pdfData.employee_references.length) {
    //     pdfData.employee_references.map((item) =>
    //       employee_references.push([
    //         item.name,
    //         item.organization,
    //         item.designation,
    //         item.relationship,
    //         item.email,
    //         item.contact,
    //       ]),
    //     )
    //   } else {
    //     for (let i = 0; i < 3; i++) {
    //       employee_references.push([
    //         { content: '' },
    //         { content: '' },
    //         { content: '' },
    //         { content: '' },
    //         { content: '' },
    //         { content: '' },
    //       ])
    //     }
    //   }

    //   return employee_references
    // }
    // doc.autoTable({
    //   startY: startYForTable12,
    //   margin: { top: 40 },
    //   head: ReferenceTable, // Header rows for second table
    //   body: ReferenceDetails(), // Body rows for second table
    //   theme: 'plain',
    //   tableLineColor: '#3c4b64',
    //   tableLineWidth: 0.2,
    //   tableWidth: 'auto', // Set table width automatically
    //   headStyles: { fillColor: [217, 218, 219] },
    //   styles: {
    //     lineColor: '#3c4b64',
    //     lineWidth: 0.2,
    //     halign: 'center',
    //     font: 'helvetica',
    //   },
    //   didDrawPage: function (data) { },

    // const addFooter = (doc) => {
    //   const pageCount = doc.internal.getNumberOfPages()
    //   let startPage = 1;
    //   for (let i = 1; i <= pageCount; i++) {
    //     doc.setPage(i)
    //     doc.setTextColor('black')
    //     doc.setFontSize(9)

    //     const lineHeight = 286 // Adjust this value as needed
    //     const lineWidth = 182 // Adjust this value as needed
    //     const lineX = 14 // Adjust this value as needed
    //     const lineY = lineHeight
    //     doc.line(lineX, lineY, lineX + lineWidth, lineY)
    //     // doc.text(`Page ${startPage} / ${pageCount}`, 190, 270, { align: 'right' })
    //     // startPage++;
    //     // if (startPage > 3) {
    //     //   startPage = 1
    //     // }
    //   }
    // }
  })
  doc.save('CoverLetter.pdf')
}

export default HrDigitalizationPDF
